import { createClass as _createClass } from "\0rollupPluginModLoBabelHelpers.js";
import { assertThisInitialized as _assertThisInitialized } from "\0rollupPluginModLoBabelHelpers.js";
import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";

var _dec, _class, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "78bf10zA4NN9KpJgnScUYzu", "UIColliderTip", undefined);

import { _decorator, Component } from 'cc';
var ccclass = _decorator.ccclass,
    property = _decorator.property;
export var UIColliderTip = (_dec = ccclass('UIColliderTip'), _dec(_class = (_temp = /*#__PURE__*/function (_Component) {
  _inheritsLoose(UIColliderTip, _Component);

  function UIColliderTip() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "_attachUuid", "");

    return _this;
  }

  _createClass(UIColliderTip, [{
    key: "attachUuid",
    get: function get() {
      return this._attachUuid;
    },
    set: function set(v) {
      this._attachUuid = v;
    } // update (deltaTime: number) {
    //     // [4]
    // }

  }]);

  return UIColliderTip;
}(Component), _temp)) || _class);
/**
 * [1] Class member could be defined like this.
 * [2] Use `property` decorator if your want the member to be serializable.
 * [3] Your initialization goes here.
 * [4] Your update function goes here.
 *
 * Learn more about scripting: https://docs.cocos.com/creator/3.0/manual/en/scripting/
 * Learn more about CCClass: https://docs.cocos.com/creator/3.0/manual/en/scripting/ccclass.html
 * Learn more about life-cycle callbacks: https://docs.cocos.com/creator/3.0/manual/en/scripting/life-cycle-callbacks.html
 */

_cclegacy._RF.pop();